import type { SVGProps } from 'react';
const SvgCallMissedOutgoing = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#call_missed_outgoing_svg__a)">
      <path
        fill="currentColor"
        d="m3 8.41 9 9 7-7V15h2V7h-8v2h4.59L12 14.59 4.41 7 3 8.41Z"
      />
    </g>
    <defs>
      <clipPath id="call_missed_outgoing_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCallMissedOutgoing;
